@use "../../../../shared/scss" as *;

:host {
  .button-container {
    display: grid;
    border-radius: $pds-border-radius-large;

    background-color: $pds-theme-light-background-surface;
    gap: $pds-spacing-static-small;
    padding: p-px-to-rem(20px);
    margin-block-start: $pds-spacing-static-medium;

    @include pds-media-query-min("s") {
      margin-block-start: initial;
      background-color: $pds-theme-light-background-base;
      gap: $pds-spacing-static-medium;
      padding: p-px-to-rem(24px);
    }

    .login {
      @include pds-media-query-min-max("base", "s") {
        inline-size: 100%;
      }
    }
  }

  .headline {
    font-size: p-px-to-rem(22px);
  }

  .subline {
    margin-block-end: $pds-spacing-static-small;
  }

  phn-p-link-pure {
    float: inline-start;
    text-decoration: underline;
    color: black;
  }
}
